import request from '@/axios/request'

export function articleList () {
    return request({
        url: '/notice',
        method: 'get'
    })
}

export function articleDetial (id) {
    return request({
        url: `/notice/${id}`,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/article.js